(function() {
	'use strict';

	angular
	.module('gatewayApp')
	.config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider
		.state('transaction-charges-summary', {
			parent: 'entity',
			params:{screen: 'TransactionChargesSummary'},
			url: '/transaction-charges-summary',
			data: {
				authorities: ['ROLE_USER'],
				pageTitle: 'global.title'
			},
			ncyBreadcrumb: {
				label: '{{ "global.menu.transactionChargesSummary.main" | translate }}',
				parent: 'home'
			},
			views: {
				'content@': {
					templateUrl: 'app/entities/transaction-charges-summary/transaction-charges-summary.html',
					controller: 'TransactionChargesSummaryViewController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
					$translatePartialLoader.addPart('transactionChargesSummary');
					$translatePartialLoader.addPart('error');
					$translatePartialLoader.addPart('global');
					return $translate.refresh();
				}],
				configSetting :['GlobalValues', function(GlobalValues) {
                    return GlobalValues.getConfigSettings();
                }],
                systemSettings: ['IntradayMarket', function(IntradayMarket) {
                    return IntradayMarket.getCurrentBusinessDate().$promise;
                }],
                previousSystemSettings:['TransactionChargesSummaryView',function(TransactionChargesSummaryView){
                	return TransactionChargesSummaryView.getPreviousBusinessDate().$promise;
                }],
				financialYears: ['StaticLookUp', function(StaticLookUp){
					return StaticLookUp.getPastAndPresentFinancialYears().$promise;
				}]

			}
		})   

	};
})();
